// Content-addressing primitives over the spec-mandated reference codecs (§3.2, §3.7):
//   @atcute/cid  — CIDv1, base32, sha-256; codec 0x55 (raw) / 0x71 (dag-cbor)
//   @atcute/cbor — dCBOR42 / DRISL (NOT @ipld/dag-cbor, which produces different bytes)
import { create, toString as cidToString } from "@atcute/cid";
import { encode } from "@atcute/cbor";

const CODEC_RAW = 0x55; // 85
const CODEC_DAG_CBOR = 0x71; // 113

/** Hash raw file bytes to a `raw` CIDv1 string (base32, `b`-prefixed). Path is not part of identity (§3.3). */
export async function rawCid(bytes: Uint8Array): Promise<string> {
  const cid = await create(CODEC_RAW, bytes);
  return cidToString(cid);
}

/**
 * Canonically encode an object with dCBOR42 and return both the encoded bytes and
 * their `dag-cbor` CIDv1 string. Used for the MASL → root CID (§3.7). The encoder
 * sorts map keys, omits `undefined` values, and emits tag-42 for `{ $link }` links.
 */
export async function dagCbor(obj: unknown): Promise<{ cid: string; bytes: Uint8Array }> {
  const bytes = encode(obj);
  const cid = await create(CODEC_DAG_CBOR, bytes);
  return { cid: cidToString(cid), bytes };
}
